/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Cashback Styled components
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const PageCashbackSideMenuWidth = 262;

export const PageCashbackStyled = styled.div.attrs({
    className: 'page-account-cashback cashback',
})`
    display: grid;
    grid-template-columns: ${PageCashbackSideMenuWidth}px calc(100% - ${PageCashbackSideMenuWidth}px);
    grid-template-rows: min-content;
    height: 100%;
    max-width: 100%;

    .cashback__title {
        padding-bottom: 20px;
        ${fonts.textHeader3};
        margin-bottom: 0;
    }

    .cashback__account-selector {
        display: flex;
        align-items: center;
        justify-self: end;
        align-self: end;

        .cashback-text {
            color: ${colors.textColorOpacity}
        }

        .select-container {
            border: none;
            padding-right: 40px;
            font-size: 15px;
            ${fonts.textLink};
        }

        .input__container.select__search-input {
            margin: 12px;
            width: auto;

            img {
                width: 24px;
            }
            input {
                height: 48px;
                padding-left: 20px;
                padding-right: 40px;
                max-width: 200px;
                box-sizing: border-box;
                ${fonts.textMain};
            }
        }

        .select__select-list {
            padding: 0;
        }

        .select__select-item {
            ${fonts.textMain};
            height: 40px !important;
            padding: 8px 32px;
            &:focus,
            &:hover {
                background-color: ${colors.backgroundColorModal};
            }
        }
    }

    .cashback__menu {
        .side-menu {
            padding-top: 32px;
            border-top: 1px solid ${colors.borderColorSeparate};
            border-left: none;
            border-bottom: none;
        }
    }

    .cashback__content {
        position: relative;
        padding: 32px;
        border-top: 1px solid ${colors.borderColorSeparate};
    }
`;

export const CashbackTextStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `cashback-text ${className || ''}`,
}))<{ font?: string } & IAttrStyled>`
    ${props => props.font ?? fonts.textMain};
`;
